<form [formGroup]="equipmentForm" *ngIf="!isLoading; else loadingAnimation">
    <app-picklist
        *ngIf="partNumber"
        [source]="equipments"
        [target]="partNumber.equipment"
        [disabled]="isReadOnly()"
        [formControl]="equipmentForm.controls['equipment']"
        formControlName="equipment"
        [sourceHeader]="'admin.partNumbers.create-modal.pick-list.equipment.leftHeader' | translate"
        [targetHeader]="'admin.partNumbers.create-modal.pick-list.equipment.rightHeader' | translate">
    </app-picklist>
</form>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
